import { GA360_MAPPING } from "../utils/GA360Fields";
export type CategoryPath = Array<string>;
export function sanitize(fieldValue: string): string {
	if (!fieldValue) {
		return "-";
	}

	const replacedURI = fieldValue.toLowerCase().replace("|", "/");

	try {
		return decodeURI(replacedURI);
	} catch {
		return replacedURI;
	}
}

function formPageTitle(pageHeadline: string, templateType: string) {
	return [sanitize(pageHeadline), sanitize(templateType)].join("|");
}

function formPageName(data: Record<string, any>, solution: string, categoryPath?: CategoryPath) {
	const sanitizedPath = data.sourcePath ? data.sourcePath.split("/").filter(String).slice(0, 2).map(sanitize) : [];
	const components = [sanitize(data.pageHeadline), data.country, solution];
	const sanitizedCategoryPath = categoryPath?.map(x => sanitize(x)) || [];
	return components.concat(sanitizedPath).concat(sanitizedCategoryPath).join("|");
}

const typeSpecificTranslations = {
	"search.filter": {
		type: "searchFilterType",
		name: "searchFilterName",
		key: "searchFilterKey",
	},
	"search.trigger": {
		type: "GA360_searchType",
	},
	"search.result": {
		autoCorrectedSolrQuery: "GA360_autoCorrectedQuery",
		pageNumber: "GA360_searchPagenumber",
	},
	"search.next": {
		pageNumber: "GA360_searchPagenumber",
	},
	"content.result": {
		pageNumber: "GA360_contentSearchPagenumber",
	},
	"content.next": {
		pageNumber: "GA360_contentSearchPagenumber",
	},
};
// This function mutates the event by adding everything Web Analytics specific
export function enrichEvent(event: Record<string, any>, data: Record<string, any>): Record<string, any> {
	const eventType = event["event"];

	if (eventType === "page.impression" && data) {
		const additionalData: Map<string, any> = new Map();
		additionalData.set("pageTitle", formPageTitle(data.pageHeadline, data.templateType));
		additionalData.set("pageName", formPageName(data, event.solution, data.categoryPath));
		additionalData.set("pageURLwp", data.href);
		const isNotFoundPage = data.pageHeadline === "notfound";
		additionalData.set("errorPage", isNotFoundPage ? "errorpage" : "no-error");
		additionalData.set("statusCode", isNotFoundPage ? 404 : 200);
		additionalData.set("shopChannel", data.shopChannel);
		const customerTypeMshop = data.customerType;

		// only include this field if it is non-empty, or else we risk overwriting it in the GA data layer
		if (customerTypeMshop !== "") {
			additionalData.set("customerTypeMshop", customerTypeMshop);
		}

		if (data.customerBuyable) {
			additionalData.set("customerBuyable", data.customerBuyable);
		}

		if (data.employeeBuyable) {
			additionalData.set("employeeBuyable", data.employeeBuyable);
		}

		if (data.selectedDeliveryMode) {
			additionalData.set("selectedDeliveryMode", data.selectedDeliveryMode);
		}

		if (data.availableDeliveryModes) {
			additionalData.set("availableDeliveryModes", data.availableDeliveryModes);
		}

		additionalData.forEach((value, key) => (event[key] = value));
	}

	if (eventType in typeSpecificTranslations) {
		Object.entries(typeSpecificTranslations[eventType]).forEach(([key, translatedKey]) => {
			//@ts-expect-error: TODO unknown type of translatedKey
			event[translatedKey] = event[key];
		});
	}

	return Object.fromEntries(Object.entries(event).map(([key, value]) => [GA360_MAPPING[key] ?? key, value]));
}
